import {post} from '../utils'

export default host => (id, mail= 1) => post(`${host}/contentCreators/${id}/askToRegister?mail=${mail}`)